import { useId, useState } from "react";
import {
  countInspiratieIdeeen,
  INSPIRATIE_ONDERWERPEN,
} from "../content/inspiratie-data";

export function InspiratiePanel() {
  const baseId = useId();
  const [openIds, setOpenIds] = useState<Set<string>>(() => new Set());

  const toggle = (id: string) => {
    setOpenIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  return (
    <section className="emdr-inspiratie" aria-labelledby={`${baseId}-heading`}>
      <header className="emdr-inspiratie__hero">
        <span className="emdr-inspiratie__badge">Ideeënbank</span>
        <h2 id={`${baseId}-heading`} className="emdr-inspiratie__title">
          Inspiratie voor je sessie
        </h2>
        <p className="emdr-inspiratie__lead">
          Zeven gebieden met concrete taakideeën voor werkgeheugenbelasting
        </p>
      </header>

      <div className="emdr-inspiratie__list">
        {INSPIRATIE_ONDERWERPEN.map((onderwerp, index) => {
          const isOpen = openIds.has(onderwerp.id);
          const panelId = `${baseId}-panel-${onderwerp.id}`;
          const triggerId = `${baseId}-trigger-${onderwerp.id}`;
          const ideeCount = countInspiratieIdeeen(onderwerp);

          return (
            <article
              key={onderwerp.id}
              className={`emdr-inspiratie-topic${isOpen ? " is-open" : ""}`}
            >
              <button
                type="button"
                id={triggerId}
                className="emdr-inspiratie-topic__trigger"
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => toggle(onderwerp.id)}
              >
                <span className="emdr-inspiratie-topic__index" aria-hidden="true">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <span className="emdr-inspiratie-topic__head">
                  <span className="emdr-inspiratie-topic__title">{onderwerp.titel}</span>
                  <span className="emdr-inspiratie-topic__intro">{onderwerp.intro}</span>
                </span>
                <span className="emdr-inspiratie-topic__meta">
                  <span className="emdr-inspiratie-topic__count">
                    {ideeCount} ideeën
                  </span>
                  <span className="emdr-inspiratie-topic__chevron" aria-hidden="true" />
                </span>
              </button>

              <div
                id={panelId}
                role="region"
                aria-labelledby={triggerId}
                className="emdr-inspiratie-topic__panel"
                hidden={!isOpen}
              >
                {onderwerp.subcategorieen.map((sub) => (
                  <section
                    key={sub.titel}
                    className="emdr-inspiratie-sub"
                    aria-label={sub.titel}
                  >
                    <h3 className="emdr-inspiratie-sub__title">{sub.titel}</h3>
                    <ul className="emdr-inspiratie-ideeen">
                      {sub.ideeen.map((idee) => (
                        <li key={idee} className="emdr-inspiratie-idee">
                          <span className="emdr-inspiratie-idee__marker" aria-hidden="true" />
                          <span>{idee}</span>
                        </li>
                      ))}
                    </ul>
                  </section>
                ))}
              </div>
            </article>
          );
        })}
      </div>

      <p className="emdr-inspiratie__footnote">
        Heb je een goed idee dat hier nog ontbreekt? We voegen het graag toe. Mail het
        naar{" "}
        <a href="mailto:rianne@interactggz.nl">rianne@interactggz.nl</a>
      </p>
    </section>
  );
}
